// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3AGzq","description":"PatientConsentPreview_description__2Z4Tn"};